import cx from 'classnames'

type DealsHeaderProps = {
  className?: string
  isCompleted: boolean
  isFilterable: boolean
}

type DealHeaderButtonProps = {
  text: string
  isFilterable?: boolean
}

const DealHeaderButton = ({ isFilterable, text }: DealHeaderButtonProps) => {
  return (
    <button className="deal-button">
      {text}

      {isFilterable && (
        <div className="ml-2 flex flex-col gap-[2px]">
          <svg
            width="7"
            height="5"
            viewBox="0 0 7 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 4L4 1L6.5 4" stroke="#B9B9B9" />
          </svg>
          <svg
            width="7"
            height="5"
            viewBox="0 0 7 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6.5 1L3.5 4L1 1" stroke="#B9B9B9" />
          </svg>
        </div>
      )}

      <style jsx>{`
        .deal-button {
          @apply inline-flex items-center font-ibm text-[12px] font-medium uppercase text-gray-600;
        }
      `}</style>
    </button>
  )
}

function DealsHeader(props: DealsHeaderProps) {
  const { className, isCompleted, isFilterable } = props
  return (
    <div
      className={cx(
        'deal-header hidden lg:grid',
        { completed: isCompleted },
        className
      )}
    >
      <div>
        <DealHeaderButton text="Seller" isFilterable={isFilterable} />
      </div>
      {isCompleted && (
        <div>
          <DealHeaderButton text="Buyer" isFilterable={isFilterable} />
        </div>
      )}
      <div className="text-center">
        <DealHeaderButton text="Asset Name" isFilterable={isFilterable} />
      </div>
      <div className="text-center">
        <DealHeaderButton text="Asset Type" isFilterable={isFilterable} />
      </div>
      <div className="text-center">
        <DealHeaderButton text="Advisor" isFilterable={isFilterable} />
      </div>
      <div className="text-right">
        <DealHeaderButton text="Launch Date" isFilterable={isFilterable} />
      </div>
      <style jsx>{`
        .deal-header {
          @apply sticky top-[106px] gap-12 bg-white px-6 py-2 font-ibm;
          grid-template-columns: repeat(5, minmax(30vw, 1fr));
        }

        .deal-header.completed {
          grid-template-columns: repeat(6, minmax(30vw, 1fr));
        }

        @screen md {
          .deal-header {
            grid-template-columns: repeat(5, minmax(20vw, 1fr));
          }
          .deal-header.completed {
            grid-template-columns: repeat(6, minmax(20vw, 1fr));
          }
        }

        @screen lg {
          .deal-header {
            @apply w-full grid-cols-5;
            border-bottom: dashed 1px black;
          }

          .deal-header.completed {
            @apply grid-cols-6;
          }
        }

        @screen xl {
          .deal-header {
            @apply top-[134px];
          }
        }
      `}</style>
    </div>
  )
}

export default DealsHeader
